import React, { useContext } from 'react';
import PaymentPageContainerComponent from './PaymentPageContainer/PaymentPageContainer.container';
import { I18nContext } from 'utils/I18n/context';

const PaymentPage = () => {
    const { t } = useContext(I18nContext);
    const staticNames = t?.paymentPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content">
                <PaymentPageContainerComponent />
            </section>
        </React.Fragment>
    );
};

export default PaymentPage;
